export default __webpack_public_path__ + "static/karolinap-6ecac35b982700408d4a6aacba6be0f5.jpg";